import { Head } from "../components/Head";

/** What Musette does with a rider's data. Needed for Google's sign-in screen; the full notice comes before sign-up opens. */
export function Privacy() {
  return (
    <main class="screen signal">
      <Head right="Privacy" />
      <section class="stack" style="margin-top: var(--space-5)">
        <span class="say">Musette is a training app, invite only while it's tested with a small group of riders.</span>
        <div class="card prose-s">
          <p>It reads your Strava activities to show your rides and your progress, and it reads your Google Calendar and adds, moves or removes a ride only when you tap to. It reads nothing else from either account.</p>
          <p>Everything it keeps sits in your own account on Musette's server, apart from every other rider's. Nothing is sold, shared, shown to anyone else or used to train any model.</p>
          <p>You can disconnect Strava at strava.com/settings/apps and Google at myaccount.google.com/permissions at any time; Musette then keeps nothing it can use.</p>
        </div>
        <span class="label">Questions: kyleunwin@gmail.com. Last updated 26 October 2026.</span>
      </section>
    </main>
  );
}
